import React, { Ref } from 'react';
import { Checkbox as $Checkbox } from 'antd';
import { CheckboxProps as $CheckboxProps } from 'antd/lib/checkbox/Checkbox';
import { ControllerRenderProps } from 'react-hook-form';

export type CheckboxProps = ControllerRenderProps & $CheckboxProps;

export default React.forwardRef(
  (props: CheckboxProps, ref: Ref<HTMLInputElement>) => {
    const { value, ...restProps } = props;

    return (
      // eslint-disable-next-line react/jsx-pascal-case
      <$Checkbox {...restProps} ref={ref} checked={value} />
    );
  },
);
